const state = {
	campus_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
